module.exports = __webpack_public_path__ + "static/img/1958_09_23_WestdeutscheRundschau_Wuppertal.ff9d7df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_23_WestdeutscheRundschau_Wuppertal.jpg
// module id = rO3A
// module chunks = 0